import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { PdDefaultWizardStep } from "../pd-default-wizard-step/PdDefaultWizardStep.js";
import { css, html } from "lit";
import { property, state } from "lit/decorators.js";
import "@progressive-development/pd-order/pd-order-summary";
//#region src/default-step-summary/DefaultStepSummary.ts
/**
* DefaultStepSummary - Abstract base class for wizard summary steps
*
* Provides integration with pd-order-summary component for displaying
* a summary of all wizard steps before final submission.
*
* @example
* ```typescript
* interface OrderFormData {
*   name: string;
*   email: string;
*   product: string;
* }
*
* @customElement("my-summary-step")
* export class MySummaryStep extends DefaultStepSummary<OrderFormData> {
*   _withAgreement = true;
*
*   _prepareOrderSteps(): OrderStep[] {
*     return [
*       {
*         key: "contact",
*         name: "Contact Info",
*         data: [
*           { name: "Name", val: this.orderForSummary?.name },
*           { name: "Email", val: this.orderForSummary?.email },
*         ],
*       },
*     ];
*   }
*
*   _getConditions() {
*     return html`<a href="/terms">Terms and Conditions</a>`;
*   }
* }
* ```
*/
/**
* Abstract base class for wizard summary steps.
*
* @typeParam T - The complete order/wizard form data type
*/
var DefaultStepSummary = class extends PdDefaultWizardStep {
	constructor(..._args) {
		super(..._args);
		this.withPayment = false;
		this.wizardSteps = [];
		this._orderSteps = [];
	}
	static {
		this.styles = [css`
      pd-order-summary {
        padding-bottom: 1.3em;
      }
    `];
	}
	update(changedProps) {
		if (changedProps.has("orderForSummary") && this.orderForSummary) this._orderSteps = this._prepareOrderSteps();
		super.update(changedProps);
	}
	get valid() {
		return this._isValidFormData();
	}
	async triggerValidate() {
		return this.valid;
	}
	setFormData(currentOrder) {
		return currentOrder;
	}
	render() {
		return this.renderSummary();
	}
	/** Render the summary component */
	renderSummary() {
		return html`
      <pd-order-summary
        id="stepFormContainerId"
        ?withPayment="${this.withPayment}"
        .order="${this.orderForSummary}"
        ?withAgreement="${this._withAgreement}"
        .orderSteps="${this._orderSteps}"
      >
        ${this._withAgreement ? html`<span slot="legal">${this._getConditions()}</span>` : ""}
      </pd-order-summary>
    `;
	}
};
__decorate([property({ type: Boolean })], DefaultStepSummary.prototype, "withPayment", void 0);
__decorate([property({ type: Object })], DefaultStepSummary.prototype, "orderForSummary", void 0);
__decorate([property({ type: Array })], DefaultStepSummary.prototype, "wizardSteps", void 0);
__decorate([state()], DefaultStepSummary.prototype, "_orderSteps", void 0);
//#endregion
export { DefaultStepSummary };
